import * as React from "react";
const SVGComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    imageRendering="optimizeQuality"
    fillRule="evenodd"
    clipRule="evenodd"
    viewBox="0 0 512 390.76"
    {...props}
  >
    <path
      fill="#263036"
      d="M34.667 0h442.667C496.417 0 512 15.582 512 34.665v321.427c0 19.041-15.583 34.668-34.666 34.668H34.667C15.584 390.76 0 375.133 0 356.092V34.665C0 15.582 15.584 0 34.667 0zm453.457 97.04H23.876v262.428a9.535 9.535 0 009.584 9.582h444.914a9.527 9.527 0 009.584-9.582V97.04h.166z"
    />
    <path
      fill="#fff"
      d="M488.124 97.04H23.876v262.428a9.535 9.535 0 009.584 9.582h444.914a9.527 9.527 0 009.584-9.582V97.04h.166z"
    />
    <path
      fill="#0CB2ED"
      d="M59.778 131.215h392.444c4.334 0 7.878 3.551 7.878 7.878v78.23c0 4.326-3.551 7.878-7.878 7.878H59.778c-4.327 0-7.878-3.545-7.878-7.878v-78.23c0-4.333 3.545-7.878 7.878-7.878z"
    />
    <path
      fill="#263036"
      d="M58.596 257.057h394.809v18.397H58.596zM58.596 307.232h394.809v18.397H58.596z"
    />
    <path
      fill="#FFD150"
      d="M386.335 38.957c9.456 0 17.124 7.667 17.124 17.126 0 9.458-7.668 17.124-17.124 17.124-9.459 0-17.127-7.666-17.127-17.124 0-9.459 7.668-17.126 17.127-17.126z"
    />
    <path
      fill="#F26A64"
      d="M328.334 38.957c9.457 0 17.124 7.667 17.124 17.126 0 9.458-7.667 17.124-17.124 17.124-9.458 0-17.126-7.666-17.126-17.124 0-9.459 7.668-17.126 17.126-17.126z"
    />
    <path
      fill="#0CB2ED"
      d="M444.334 38.957c9.459 0 17.124 7.667 17.124 17.126 0 9.458-7.665 17.124-17.124 17.124-9.458 0-17.126-7.666-17.126-17.124.043-9.459 7.708-17.126 17.126-17.126z"
    />
  </svg>
);
export default SVGComponent;
